/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
// react plugin used to create charts
// import { Line, Bar } from "react-chartjs-2";
import Swal from "sweetalert2";
import axios from "axios";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { BASE_URL } from "utils/constants";

// const eagleCardBackground = process.env.PUBLIC_URL + '/assets/images/-3.png';
// const calculate_eagleCardCount_from_Reinforcements = (Reinforcements) => {
//     let total = 0;
//     for (let index = 0; index < (Reinforcements?.length ?? 0); index++) {

//         total += +(Reinforcements[index]?.points ?? 0);
//     }
//     return Math.floor(total / 10);
// }


function Dashboard() {
    const [services, setServices] = useState([]);
    // const [Reinforcements, setReinforcements] = useState([]);
    //   const [first, setfirst] = useState(second)
    const [eagleCardCount, setEagleCardCount] = useState(0);
    const [RP, setRP] = useState(0);
    const [consumed, setConsumed] = useState(0);
    const [totalEagles, setTotalEagles] = useState(0);

    const availableEagleCards = Math.max(0, eagleCardCount);
    const previewEagleCards = Array.from({ length: Math.min(availableEagleCards, 5) }, (_, index) => index);
    const rewardStats = [
        { label: "RP", value: RP, hint: "Reinforcement Points" },
        { label: "Available Eagle Cards", value: availableEagleCards, hint: "Ready to use" },
        { label: "Used Eagle Cards", value: consumed, hint: `${totalEagles} total earned` },
    ];



    useEffect(async () => {
        try {
            const res = await axios.get(`${BASE_URL}/services/getservices.php`);
            setServices(res.data.data);
        } catch {
            Swal.fire('Failed to get services!', '', 'error');
        }
    }, [])
    // useEffect(async () => {
    //     try {
    //         const res = await axios.get(`${BASE_URL}/reinforcements/getreinforcements.php`);
    //         setReinforcements(res.data.data);
    //         const tmp_Reinforcements = res?.data?.data ?? [];
    //         if (tmp_Reinforcements && (tmp_Reinforcements?.length ?? false)) {
    //             setEagleCardCount(calculate_eagleCardCount_from_Reinforcements(tmp_Reinforcements));
    //         }
    //     } catch {
    //         Swal.fire('Failed to get reinforcements!', '', 'error');
    //     }
    // }, [])
    useEffect(async () => {
        try {
            const res = await axios.get(`${BASE_URL}/eagle_card/get_eagle_cards.php`);
            
            setEagleCardCount(res?.data?.data?.remaining ?? 0);
            setRP(res?.data?.data?.RP ?? 0)
            setConsumed(res?.data?.data?.consumed ?? 0)
            setTotalEagles(res?.data?.data?.total_eagle_cards ?? 0 )
        } catch {
            Swal.fire('Failed to get Eagle Cards!', '', 'error');
        }
    }, [])
    return (
        <>
            <PanelHeader size="sm" />

            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardHeader>
                                <h4 className="title">Rewards</h4>
                                <p className="category" style={{ marginBottom: 0 }}>
                                    Earn RP from teachers. Every 10 RP creates 1 Eagle Card.
                                </p>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    {rewardStats.map((stat) => (
                                        <Col lg={4} md={6} xs={12} key={stat.label}>
                                            <div
                                                style={{
                                                    border: "1px solid #e9ecef",
                                                    borderRadius: "8px",
                                                    padding: "18px",
                                                    marginBottom: "16px",
                                                    minHeight: "140px",
                                                    background: "#ffffff",
                                                }}
                                            >
                                                <p style={{ color: "#6c757d", fontSize: "13px", fontWeight: 600, marginBottom: "8px", textTransform: "uppercase" }}>
                                                    {stat.label}
                                                </p>
                                                <div style={{ color: "#0A1931", fontSize: "34px", fontWeight: 700, lineHeight: 1 }}>
                                                    {stat.value}
                                                </div>
                                                <p style={{ color: "#6c757d", margin: "12px 0 0" }}>
                                                    {stat.hint}
                                                </p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>

                                <Row>
                                    <Col lg={4} xs={12}>
                                        <div
                                            style={{
                                                background: "#f8f9fa",
                                                borderRadius: "8px",
                                                padding: "20px",
                                                height: "100%",
                                            }}
                                        >
                                            <h5 style={{ marginTop: 0, fontWeight: 700 }}>How it works</h5>
                                            <p style={{ marginBottom: "10px" }}>Teachers award RP.</p>
                                            <p style={{ marginBottom: "10px" }}>10 RP = 1 Eagle Card.</p>
                                            <p style={{ marginBottom: 0 }}>Teachers use cards for your benefits.</p>
                                        </div>
                                    </Col>
                                    <Col lg={8} xs={12}>
                                        <div
                                            style={{
                                                alignItems: "center",
                                                background: "#fff8e6",
                                                border: "1px solid #ffe3a3",
                                                borderRadius: "8px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                minHeight: "340px",
                                                padding: "20px",
                                                position: "relative",
                                                textAlign: "center",
                                            }}
                                        >
                                            {availableEagleCards > 0 ? (
                                                <>
                                                    <div
                                                        style={{
                                                            height: "240px",
                                                            margin: "0 auto 18px",
                                                            position: "relative",
                                                            width: `${160 + (previewEagleCards.length - 1) * 18}px`,
                                                        }}
                                                    >
                                                        {previewEagleCards.map((count) => (
                                                            <img
                                                                src="assets/images/eagle_card_background.jpg"
                                                                key={count}
                                                                style={{
                                                                    position: "absolute",
                                                                    left: `${count * 18}px`,
                                                                    top: `${count * 8}px`,
                                                                    width: "160px",
                                                                    height: "230px",
                                                                    backgroundColor: "white",
                                                                    boxShadow: "0 8px 18px rgba(10, 25, 49, 0.18)",
                                                                    borderRadius: "8px",
                                                                    objectFit: "cover",
                                                                }}
                                                                alt="Eagle Card"
                                                            />
                                                        ))}
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                right: "-10px",
                                                                top: "-10px",
                                                                backgroundColor: "#0A1931",
                                                                color: "white",
                                                                borderRadius: "999px",
                                                                minWidth: "40px",
                                                                height: "40px",
                                                                padding: "0 10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontSize: "15px",
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            {availableEagleCards}
                                                        </div>
                                                    </div>
                                                    <strong>{availableEagleCards} Eagle Card{availableEagleCards === 1 ? "" : "s"} available</strong>
                                                    <span style={{ color: "#6c757d", marginTop: "6px" }}>
                                                        Ask teachers to use them.
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <strong>No available Eagle Cards yet</strong>
                                                    <span style={{ color: "#6c757d", marginTop: "8px" }}>
                                                        Keep earning RP.
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                            </CardBody>
                            {/* <CardBody>
                                <h5> Reinforcement points : </h5>
                                <Line color="blue" Reinforcements={Reinforcements} />
                            </CardBody> */}
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Card>
                            <CardHeader>
                                <h4 className="title">Services</h4>
                                <hr />
                            </CardHeader>
                            <CardBody className="all-icons">
                                <Row>
                                    {services.map((s, key) => {
                                        return (
                                            <Col
                                                xl={3}
                                                lg={4}
                                                md={4}
                                                sm={6}
                                                xs={12}
                                                className="font-icon-list"
                                                key={key}
                                            >
                                                <a href={s.link} target="_blank" rel="noreferrer">
                                                    {s.type === 'edu' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{ height: '250px', boxShadow: '5px 10px #FFA400' }}>
                                                        <img className="col-12" src={s.image} alt='service image' style={{ maxWidth: '60%', height: '90px' }} />
                                                        <p className="col-12 text-center fw-bolder" style={{ fontSize: "14pt", color: "#0A1931", fontWeight: 'bold' }} >{s.name}</p>
                                                    </div>}
                                                    {s.type === 'microsoft' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{ height: '250px', boxShadow: '5px 10px #39A2DB' }}>
                                                        <img className="col-12" src={s.image} alt='service image' style={{ maxWidth: '35%', height: '70px' }} />
                                                        <p className="col-12 text-center fw-bolder" style={{ fontSize: "14pt", color: "#0A1931", fontWeight: 'bold' }} >{s.name}</p>
                                                    </div>}
                                                    {s.type === 'google' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{ height: '250px', boxShadow: '5px 10px #81B214' }}>
                                                        <img className="col-12" src={s.image} alt='service image' style={{ maxWidth: '35%', height: '70px' }} />
                                                        <p className="col-12 text-center fw-bolder" style={{ fontSize: "14pt", color: "#0A1931", fontWeight: 'bold' }} >{s.name}</p>
                                                    </div>}
                                                </a>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default Dashboard;
